import { useEffect, useState, useCallback } from "react";
import { api, errMsg } from "./api";
import { toast } from "sonner";

export function useResource(res, params) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const key = JSON.stringify(params || {});
  const load = useCallback(async () => {
    try {
      const { data } = await api.get(`/r/${res}`, { params: JSON.parse(key) });
      setItems(data);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setLoading(false);
    }
  }, [res, key]);
  useEffect(() => { load(); }, [load]);

  const save = async (body, id) => {
    try {
      const { data } = id ? await api.put(`/r/${res}/${id}`, body) : await api.post(`/r/${res}`, body);
      await load();
      return data;
    } catch (e) {
      toast.error(errMsg(e));
      throw e;
    }
  };
  const remove = async (id) => {
    try {
      await api.delete(`/r/${res}/${id}`);
      toast.success("Deleted");
      await load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return { items, loading, load, save, remove, setItems };
}

export function useGet(path, deps = []) {
  const [data, setData] = useState(null);
  const load = useCallback(async () => {
    if (!path) return;
    try {
      const r = await api.get(path);
      setData(r.data);
    } catch (e) {
      toast.error(errMsg(e));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, ...deps]);
  useEffect(() => { load(); }, [load]);
  return [data, load];
}
